import image404 from "@assets:404.jpg";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowLeft } from "react-icons/md";

export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        paddingTop: "7rem",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        <Box
          component="img"
          src={image404}
          alt=""
          width={200}
          height={200}
          sx={{
            mx: "auto",
          }}
        />
        <Typography
          variant="h1"
          sx={{
            marginTop: "1rem",
            fontSize: "34px",
            letterSpacing: "-0.025em",
            color: "gray.900",
          }}
        >
          {t("errors.oops")}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            margin: "1.5rem",
            color: "gray.600",
          }}
        >
          {t("errors.notFoundBody")}
        </Typography>
        <Box
          sx={{
            marginTop: "2.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            columnGap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={() => window.location.assign(window.location.origin)}
            sx={{
              fontWeight: "600",
            }}
            startIcon={<MdKeyboardArrowLeft />}
          >
            {t("errors.goBackHome")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
